
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames from 'classnames/bind';

import style from './style.scss';

const GetBannerTitle = props => {

    if (!props.pathName) {
        return null;
    }

    let bannerSrc = null;
    let styleName = null;
    let titleText = null;

    if (props.pathName === '/courses') {
        bannerSrc =  '/assets/images/icons/1947_word_courses_white.png';
        styleName = 'banner-title--courses';
        titleText = 'courses';
    } else if (props.pathName === '/events') {
        bannerSrc = '/assets/images/icons/1947_word_programme_white.png';
        styleName = 'banner-title--programme';
        titleText = 'programme';
    } else if (props.pathName === '/e-learning') {
        bannerSrc = '/assets/images/icons/1947_word_e-learning_white.png';
        styleName = 'banner-title--e-learning';
        titleText = 'e-learning';
    } else if (props.pathName === '/conferences') {
        bannerSrc = '/assets/images/icons/1947_word_conferences_white.png';
        styleName = 'banner-title--conferences';
        titleText = 'conferences';
    } else if (props.pathName.includes('/booking/')) {
        bannerSrc = '/assets/images/icons/1947_word_booking_white.png';
        styleName = 'banner-title--booking';
        titleText = 'booking';
    } else {
        bannerSrc = '/assets/images/icons/1947_word_training_white.png';
        styleName = 'banner-title--training';
        titleText = 'training';
    }

    return (
        <div>
            {props.pathName === '/courses' &&
                <div className={style['icon--classroom']}/>
            }

            {props.pathName === '/e-learning' &&
                <div className={style['icon--online']}/>
            }

            {props.pathName === '/conferences' &&
                <div className={style['icon--conference']}/>
            }

            {props.pathName === '/events' &&
            <div>
                <div className={style['icon--classroom']}/>
                <div className={style['icon--conference']}/>
            </div>
            }

            {titleText === 'programme' &&
                <h1 className={style['programme-title-text']}>{titleText}</h1>
            }
            {titleText === 'booking' &&
                <h1 className={style['page-title-text-booking']}>{titleText}</h1>
            }
            {titleText === 'e-learning' &&
                <h1 className={style['e-learning-title-text']}>{titleText}</h1>
            }
            {titleText !== 'programme' && titleText !== 'booking' && titleText !== 'e-learning' &&
                <h1 className={style['page-title-text']}>{titleText}</h1>
            }

        </div>
    )
}
class PageHeader extends React.Component {

    _getHeaderClass() {

        var cx = classNames.bind(style);

        var classes = {
            'header--event': this.props.pathName === '/events',
            'header--booking': this.props.pathName.includes('/booking/'),
            'header--classroom': this.props.pathName === '/courses',
            'header--online': this.props.pathName === '/e-learning',
            'header--conference': this.props.pathName === '/conferences'
        };

        if (this.props.className) {

            classes[this.props.className] = true;
        }

        return cx(classes);
    }

    render() {

        // Don't render if we're on the event detail or course detail pages
        if(!this.props.pathName || this.props.pathName.includes('/events/') || this.props.pathName.includes('/courses/')) return null;

        return (
            <div className={style['content']}>

                <header className={ this._getHeaderClass() }>

                    <div className={style['section-content']}>

                        <GetBannerTitle
                            pathName={this.props.pathName}
                        />

                        { this.props.children }

                    </div>

                </header>

            </div>
        );
    }
}

export default CSSModules(PageHeader, style);


// WEBPACK FOOTER //
// ./components/PageHeader/index.js